/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChamadoDetalhesAliases {
  CARD_0 = 'card-0',
  CARD_HISTORY = 'card-history',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FETCH_CALL = 'fetch-call',
  FETCH_HISTORY = 'fetch-history',
  FIELD_0 = 'field-0',
  FIELD_ACCREDITATION = 'field-accreditation',
  FIELD_ATTACHMENTS = 'field-attachments',
  FIELD_CALL_TYPE = 'field-call-type',
  FIELD_CANCEL_DATE = 'field-cancel-date',
  FIELD_CANCEL_REASON = 'field-cancel-reason',
  FIELD_MENSAGEM = 'field-mensagem',
  FIELD_NUMBER = 'field-number',
  FIELD_OPENNING_DATE = 'field-openning-date',
  FIELD_STATUS = 'field-status',
  FIELD_SUBJECT = 'field-subject',
  FORM_0 = 'form-0',
  FORM_CALL = 'form-call',
  HPMS_ATTACHMENTS_LIST = 'hpms-attachments-list',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  INPUT_0 = 'input-0',
  INPUT_2 = 'input-2',
  INPUT_CALL_TYPE = 'input-call-type',
  LAYOUT_0 = 'layout-0',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_CHAMADO_DETALHES = 'panel-chamado-detalhes',
  PANEL_HISTORY = 'panel-history',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_5 = 'text-5',
  TEXT_10 = 'text-10',
  TEXT_NUMBER = 'text-number',
}
export { ChamadoDetalhesAliases };
